module.exports = __webpack_public_path__ + "static/media/team-mosaic-03.2fdfcb2d.jpg";